import { useCallback } from 'react';
import {
  Button,
  IconXMark,
  LinkAuth,
  LinkAuthError,
  LinkAuthFlow,
  LinkAuthFlowBackButton,
  LinkAuthModal,
  LinkAuthModalContent,
  LinkAuthProps,
  LinkAuthTitle,
} from '@coinbase/cdp-react';
import { useUser } from 'apps/cdp-web-demo/app/(main)/UserContext';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';

import { Dialog, DialogClose } from '../Dialog/Dialog';

import styles from './LinkProfileDialog.module.css';

type LinkProfileProps = Omit<LinkAuthProps, 'children'>;

export function LinkProfileDialog({ onLinkSuccess, className = '', ...props }: LinkProfileProps) {
  const { loggedInView, setLoggedInView } = useUser();
  const { isTablet, isDesktop } = useBreakpoints();
  const isWideLayout = isTablet || isDesktop;

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        setLoggedInView(null);
      } else {
        setLoggedInView('link-profile');
      }
    },
    [setLoggedInView],
  );

  return (
    <>
      {isWideLayout && (
        <Dialog
          open={loggedInView === 'link-profile'}
          onOpenChange={handleOpenChange}
          title="Link a profile"
          className={styles['link-profile-dialog']}
        >
          <LinkAuth
            className={`${className} ${styles['link-profile']}`}
            onLinkSuccess={onLinkSuccess}
            {...props}
          >
            <div className={styles.header}>
              <LinkAuthTitle />
              <LinkAuthFlowBackButton />
              <DialogClose asChild>
                <Button
                  className={styles['close-button']}
                  aria-label="Close"
                  size="md"
                  variant="transparentSecondary"
                >
                  <IconXMark className={styles['close-icon']} />
                </Button>
              </DialogClose>
            </div>
            <div className={styles.error}>
              <LinkAuthError />
            </div>
            <LinkAuthFlow />
          </LinkAuth>
        </Dialog>
      )}
      {!isWideLayout && (
        <LinkAuthModal
          open={loggedInView === 'link-profile'}
          setIsOpen={handleOpenChange}
          onLinkSuccess={onLinkSuccess}
          {...props}
        >
          <LinkAuthModalContent />
        </LinkAuthModal>
      )}
    </>
  );
}
